export const APP_VERSION: string = 'v1.0.3.10';
export const FILTER_ALL_LABEL: string = 'All';
export const FILTER_FEATURED_LABEL: string = 'Featured';
